export default __webpack_public_path__ + "static/media/nsf.52b8de59.svg";